// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/IRANSansMobile(FaNum)-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/IRANSansMobile(FaNum)-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Javanweb.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Javanweb.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 275px) {

  .container {
    max-width: 275px;
  }
}
@media (min-width: 300px) {

  .container {
    max-width: 300px;
  }
}
@media (min-width: 350px) {

  .container {
    max-width: 350px;
  }
}
@media (min-width: 400px) {

  .container {
    max-width: 400px;
  }
}
@media (min-width: 450px) {

  .container {
    max-width: 450px;
  }
}
@media (min-width: 500px) {

  .container {
    max-width: 500px;
  }
}
@media (min-width: 550px) {

  .container {
    max-width: 550px;
  }
}
@media (min-width: 600px) {

  .container {
    max-width: 600px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 800px) {

  .container {
    max-width: 800px;
  }
}
@media (min-width: 900px) {

  .container {
    max-width: 900px;
  }
}
@media (min-width: 1000px) {

  .container {
    max-width: 1000px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1180px) {

  .container {
    max-width: 1180px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1360px) {

  .container {
    max-width: 1360px;
  }
}
@media (min-width: 1400px) {

  .container {
    max-width: 1400px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 1650px) {

  .container {
    max-width: 1650px;
  }
}
@media (min-width: 1700px) {

  .container {
    max-width: 1700px;
  }
}
@media (min-width: 1800px) {

  .container {
    max-width: 1800px;
  }
}
@media (min-width: 2000px) {

  .container {
    max-width: 2000px;
  }
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.\\!bottom-\\[50px\\] {
  bottom: 50px !important;
}
.-bottom-0 {
  bottom: -0px;
}
.-bottom-3 {
  bottom: -0.75rem;
}
.-bottom-9 {
  bottom: -2.25rem;
}
.-bottom-\\[0\\%\\] {
  bottom: -0%;
}
.-bottom-\\[10px\\] {
  bottom: -10px;
}
.-bottom-\\[200\\%\\] {
  bottom: -200%;
}
.-bottom-\\[45px\\] {
  bottom: -45px;
}
.-bottom-\\[50\\%\\] {
  bottom: -50%;
}
.-left-3 {
  left: -0.75rem;
}
.-left-6 {
  left: -1.5rem;
}
.-left-\\[3\\.5vw\\] {
  left: -3.5vw;
}
.-right-6 {
  right: -1.5rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-\\[1px\\] {
  top: -1px;
}
.-top-\\[3px\\] {
  top: -3px;
}
.-top-\\[6vw\\] {
  top: -6vw;
}
.-top-\\[8px\\] {
  top: -8px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-9 {
  bottom: 2.25rem;
}
.bottom-\\[2vw\\] {
  bottom: 2vw;
}
.bottom-\\[3\\.5vw\\] {
  bottom: 3.5vw;
}
.bottom-\\[37px\\] {
  bottom: 37px;
}
.bottom-\\[58px\\] {
  bottom: 58px;
}
.bottom-\\[60px\\] {
  bottom: 60px;
}
.left-0 {
  left: 0px;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-\\[22vw\\] {
  right: 22vw;
}
.right-\\[2vw\\] {
  right: 2vw;
}
.right-\\[30\\%\\] {
  right: 30%;
}
.right-\\[50\\%\\] {
  right: 50%;
}
.right-\\[8vw\\] {
  right: 8vw;
}
.top-0 {
  top: 0px;
}
.top-2 {
  top: 0.5rem;
}
.top-6 {
  top: 1.5rem;
}
.top-\\[12vh\\] {
  top: 12vh;
}
.top-\\[18\\%\\] {
  top: 18%;
}
.top-\\[26px\\] {
  top: 26px;
}
.top-\\[30\\%\\] {
  top: 30%;
}
.top-\\[30px\\] {
  top: 30px;
}
.top-\\[3vw\\] {
  top: 3vw;
}
.top-\\[40px\\] {
  top: 40px;
}
.top-\\[47px\\] {
  top: 47px;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-\\[65\\%\\] {
  top: 65%;
}
.\\!z-\\[200\\] {
  z-index: 200 !important;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-100 {
  z-index: 9999;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000000000\\] {
  z-index: 1000000000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[2000000000000\\] {
  z-index: 2000000000000;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[3000\\] {
  z-index: 3000;
}
.z-\\[30\\] {
  z-index: 30;
}
.z-\\[600000000000001\\] {
  z-index: 600000000000001;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-4 {
  margin: 1rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[5vw\\] {
  margin-left: 5vw;
  margin-right: 5vw;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[51px\\] {
  margin-top: 51px;
  margin-bottom: 51px;
}
.my-\\[5vh\\] {
  margin-top: 5vh;
  margin-bottom: 5vh;
}
.my-\\[60px\\] {
  margin-top: 60px;
  margin-bottom: 60px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mt-\\[25px\\] {
  margin-top: 25px !important;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-\\[100px\\] {
  margin-bottom: 100px;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[10vh\\] {
  margin-bottom: 10vh;
}
.mb-\\[12px\\] {
  margin-bottom: 12px;
}
.mb-\\[13px\\] {
  margin-bottom: 13px;
}
.mb-\\[14px\\] {
  margin-bottom: 14px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[3px\\] {
  margin-bottom: 3px;
}
.mb-\\[42px\\] {
  margin-bottom: 42px;
}
.mb-\\[45px\\] {
  margin-bottom: 45px;
}
.mb-\\[54px\\] {
  margin-bottom: 54px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.mb-\\[5vh\\] {
  margin-bottom: 5vh;
}
.mb-\\[6vw\\] {
  margin-bottom: 6vw;
}
.mb-\\[89px\\] {
  margin-bottom: 89px;
}
.mb-\\[9px\\] {
  margin-bottom: 9px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[1px\\] {
  margin-left: 1px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-\\[14px\\] {
  margin-right: 14px;
}
.mr-\\[7px\\] {
  margin-right: 7px;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[10vh\\] {
  margin-top: 10vh;
}
.mt-\\[11px\\] {
  margin-top: 11px;
}
.mt-\\[12vh\\] {
  margin-top: 12vh;
}
.mt-\\[14px\\] {
  margin-top: 14px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[22px\\] {
  margin-top: 22px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[34px\\] {
  margin-top: 34px;
}
.mt-\\[35px\\] {
  margin-top: 35px;
}
.mt-\\[38px\\] {
  margin-top: 38px;
}
.mt-\\[42px\\] {
  margin-top: 42px;
}
.mt-\\[43px\\] {
  margin-top: 43px;
}
.mt-\\[45px\\] {
  margin-top: 45px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[5vh\\] {
  margin-top: 5vh;
}
.mt-\\[60px\\] {
  margin-top: 60px;
}
.mt-\\[61px\\] {
  margin-top: 61px;
}
.mt-\\[6px\\] {
  margin-top: 6px;
}
.mt-\\[6vw\\] {
  margin-top: 6vw;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.mt-\\[8vh\\] {
  margin-top: 8vh;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[103\\/87\\] {
  aspect-ratio: 103/87;
}
.aspect-\\[160\\/106\\] {
  aspect-ratio: 160/106;
}
.aspect-\\[320\\/164\\] {
  aspect-ratio: 320/164;
}
.aspect-\\[322\\/132\\] {
  aspect-ratio: 322/132;
}
.aspect-\\[328\\/156\\] {
  aspect-ratio: 328/156;
}
.aspect-\\[4\\/4\\.5\\] {
  aspect-ratio: 4/4.5;
}
.aspect-\\[41\\/44\\] {
  aspect-ratio: 41/44;
}
.aspect-\\[6\\/1\\.7\\] {
  aspect-ratio: 6/1.7;
}
.aspect-\\[88\\/88\\] {
  aspect-ratio: 88/88;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1\\.2vw\\] {
  height: 1.2vw;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[10rem\\] {
  height: 10rem;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[12vw\\] {
  height: 12vw;
}
.h-\\[15\\.5vw\\] {
  height: 15.5vw;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[16vw\\] {
  height: 16vw;
}
.h-\\[177px\\] {
  height: 177px;
}
.h-\\[190px\\] {
  height: 190px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[2\\.5vw\\] {
  height: 2.5vw;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[20vw\\] {
  height: 20vw;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[25\\%\\] {
  height: 25%;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[2rem\\] {
  height: 2rem;
}
.h-\\[2vw\\] {
  height: 2vw;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[30vw\\] {
  height: 30vw;
}
.h-\\[31\\.5vw\\] {
  height: 31.5vw;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[34vw\\] {
  height: 34vw;
}
.h-\\[38\\.5px\\] {
  height: 38.5px;
}
.h-\\[40vh\\] {
  height: 40vh;
}
.h-\\[40vw\\] {
  height: 40vw;
}
.h-\\[45vh\\] {
  height: 45vh;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[50vh\\] {
  height: 50vh;
}
.h-\\[55\\%\\] {
  height: 55%;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[57px\\] {
  height: 57px;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[5px\\] {
  height: 5px;
}
.h-\\[5vw\\] {
  height: 5vw;
}
.h-\\[60\\%\\] {
  height: 60%;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[66px\\] {
  height: 66px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[7vw\\] {
  height: 7vw;
}
.h-\\[80\\%\\] {
  height: 80%;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[82px\\] {
  height: 82px;
}
.h-\\[85px\\] {
  height: 85px;
}
.h-\\[87px\\] {
  height: 87px;
}
.h-\\[8vw\\] {
  height: 8vw;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[91px\\] {
  height: 91px;
}
.h-\\[95\\%\\] {
  height: 95%;
}
.h-\\[9rem\\] {
  height: 9rem;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[80\\%\\] {
  min-height: 80%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-full {
  width: 100% !important;
}
.w-1 {
  width: 0.25rem;
}
.w-10 {
  width: 2.5rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100vw\\] {
  width: 100vw;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[12vw\\] {
  width: 12vw;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[14vw\\] {
  width: 14vw;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150vw\\] {
  width: 150vw;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[15vw\\] {
  width: 15vw;
}
.w-\\[18vw\\] {
  width: 18vw;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20vw\\] {
  width: 20vw;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[22vw\\] {
  width: 22vw;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[254px\\] {
  width: 254px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[25vw\\] {
  width: 25vw;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[26vw\\] {
  width: 26vw;
}
.w-\\[27px\\] {
  width: 27px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[2vw\\] {
  width: 2vw;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[30vw\\] {
  width: 30vw;
}
.w-\\[32vw\\] {
  width: 32vw;
}
.w-\\[3vw\\] {
  width: 3vw;
}
.w-\\[4\\.5\\%\\] {
  width: 4.5%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[40vw\\] {
  width: 40vw;
}
.w-\\[41px\\] {
  width: 41px;
}
.w-\\[43px\\] {
  width: 43px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[45vw\\] {
  width: 45vw;
}
.w-\\[47px\\] {
  width: 47px;
}
.w-\\[48\\%\\] {
  width: 48%;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[4vw\\] {
  width: 4vw;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[55vw\\] {
  width: 55vw;
}
.w-\\[5vw\\] {
  width: 5vw;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[62vw\\] {
  width: 62vw;
}
.w-\\[65px\\] {
  width: 65px;
}
.w-\\[66\\%\\] {
  width: 66%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[7px\\] {
  width: 7px;
}
.w-\\[7rem\\] {
  width: 7rem;
}
.w-\\[7vw\\] {
  width: 7vw;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[8vw\\] {
  width: 8vw;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[94px\\] {
  width: 94px;
}
.w-\\[9px\\] {
  width: 9px;
}
.w-\\[9vw\\] {
  width: 9vw;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[82px\\] {
  min-width: 82px;
}
.-rotate-180 {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-start {
  place-content: start;
}
.place-content-between {
  place-content: space-between;
}
.content-start {
  align-content: flex-start;
}
.content-between {
  align-content: space-between;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.\\!justify-between {
  justify-content: space-between !important;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[8vw\\] {
  gap: 8vw;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-0\\.5 {
  column-gap: 0.125rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-7 {
  column-gap: 1.75rem;
}
.gap-x-\\[10vw\\] {
  column-gap: 10vw;
}
.gap-x-\\[11px\\] {
  column-gap: 11px;
}
.gap-x-\\[12px\\] {
  column-gap: 12px;
}
.gap-x-\\[12vw\\] {
  column-gap: 12vw;
}
.gap-x-\\[15px\\] {
  column-gap: 15px;
}
.gap-x-\\[1rem\\] {
  column-gap: 1rem;
}
.gap-x-\\[1vw\\] {
  column-gap: 1vw;
}
.gap-x-\\[2\\.5vw\\] {
  column-gap: 2.5vw;
}
.gap-x-\\[20px\\] {
  column-gap: 20px;
}
.gap-x-\\[22px\\] {
  column-gap: 22px;
}
.gap-x-\\[22vw\\] {
  column-gap: 22vw;
}
.gap-x-\\[2vw\\] {
  column-gap: 2vw;
}
.gap-x-\\[30px\\] {
  column-gap: 30px;
}
.gap-x-\\[3vw\\] {
  column-gap: 3vw;
}
.gap-x-\\[45px\\] {
  column-gap: 45px;
}
.gap-x-\\[4vw\\] {
  column-gap: 4vw;
}
.gap-x-\\[5\\%\\] {
  column-gap: 5%;
}
.gap-x-\\[5px\\] {
  column-gap: 5px;
}
.gap-x-\\[5vw\\] {
  column-gap: 5vw;
}
.gap-x-\\[6px\\] {
  column-gap: 6px;
}
.gap-x-\\[6vw\\] {
  column-gap: 6vw;
}
.gap-x-\\[7px\\] {
  column-gap: 7px;
}
.gap-x-\\[8px\\] {
  column-gap: 8px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.gap-y-7 {
  row-gap: 1.75rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.gap-y-9 {
  row-gap: 2.25rem;
}
.gap-y-\\[10px\\] {
  row-gap: 10px;
}
.gap-y-\\[12px\\] {
  row-gap: 12px;
}
.gap-y-\\[1vh\\] {
  row-gap: 1vh;
}
.gap-y-\\[20px\\] {
  row-gap: 20px;
}
.gap-y-\\[2vw\\] {
  row-gap: 2vw;
}
.gap-y-\\[30px\\] {
  row-gap: 30px;
}
.gap-y-\\[32px\\] {
  row-gap: 32px;
}
.gap-y-\\[33px\\] {
  row-gap: 33px;
}
.gap-y-\\[47px\\] {
  row-gap: 47px;
}
.gap-y-\\[4px\\] {
  row-gap: 4px;
}
.gap-y-\\[4vw\\] {
  row-gap: 4vw;
}
.gap-y-\\[5px\\] {
  row-gap: 5px;
}
.gap-y-\\[5vw\\] {
  row-gap: 5vw;
}
.gap-y-\\[9px\\] {
  row-gap: 9px;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.\\!rounded-\\[10px\\] {
  border-radius: 10px !important;
}
.\\!rounded-\\[16px\\] {
  border-radius: 16px !important;
}
.\\!rounded-\\[5px\\] {
  border-radius: 5px !important;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[17px\\] {
  border-radius: 17px;
}
.rounded-\\[1rem\\] {
  border-radius: 1rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-\\[34px\\] {
  border-radius: 34px;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[3rem\\] {
  border-radius: 3rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[25px\\] {
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}
.rounded-b-\\[3rem\\] {
  border-bottom-right-radius: 3rem;
  border-bottom-left-radius: 3rem;
}
.rounded-b-\\[8px\\] {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.rounded-l-\\[9px\\] {
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-\\[12px\\] {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-\\[20px\\] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.rounded-t-\\[24px\\] {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-t-\\[26px\\] {
  border-top-left-radius: 26px;
  border-top-right-radius: 26px;
}
.rounded-t-\\[30px\\] {
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.rounded-t-\\[8px\\] {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-br-\\[39px\\] {
  border-bottom-right-radius: 39px;
}
.rounded-tl-\\[16px\\] {
  border-top-left-radius: 16px;
}
.rounded-tl-\\[9px\\] {
  border-top-left-radius: 9px;
}
.border {
  border-width: 1px;
}
.border-\\[0\\] {
  border-width: 0;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-x-\\[1px\\] {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y-\\[1px\\] {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-\\[\\#0008C3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 8 195 / var(--tw-border-opacity));
}
.border-\\[\\#0008C3\\]\\/20 {
  border-color: rgb(0 8 195 / 0.2);
}
.border-\\[\\#0008C3\\]\\/30 {
  border-color: rgb(0 8 195 / 0.3);
}
.border-\\[\\#0308C4\\]\\/10 {
  border-color: rgb(3 8 196 / 0.1);
}
.border-\\[\\#0308C4\\]\\/20 {
  border-color: rgb(3 8 196 / 0.2);
}
.border-\\[\\#ACAFEC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(172 175 236 / var(--tw-border-opacity));
}
.border-\\[\\#C9E8D5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(201 232 213 / var(--tw-border-opacity));
}
.border-\\[\\#CCCEF3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(204 206 243 / var(--tw-border-opacity));
}
.border-\\[\\#F1F1F1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(241 241 241 / var(--tw-border-opacity));
}
.border-\\[\\#F6E5CC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(246 229 204 / var(--tw-border-opacity));
}
.border-\\[\\#F7F7FC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(247 247 252 / var(--tw-border-opacity));
}
.border-\\[\\#FEC8C7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(254 200 199 / var(--tw-border-opacity));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(0 60 159 / var(--tw-border-opacity));
}
.border-primary\\/10 {
  border-color: rgb(0 60 159 / 0.1);
}
.border-primary\\/20 {
  border-color: rgb(0 60 159 / 0.2);
}
.border-primary\\/25 {
  border-color: rgb(0 60 159 / 0.25);
}
.border-primary\\/30 {
  border-color: rgb(0 60 159 / 0.3);
}
.border-primary\\/40 {
  border-color: rgb(0 60 159 / 0.4);
}
.border-primary\\/\\[0\\.25\\] {
  border-color: rgb(0 60 159 / 0.25);
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.border-textPrimary {
  --tw-border-opacity: 1;
  border-color: rgb(41 45 50 / var(--tw-border-opacity));
}
.border-textPrimary\\/10 {
  border-color: rgb(41 45 50 / 0.1);
}
.border-textPrimary\\/50 {
  border-color: rgb(41 45 50 / 0.5);
}
.border-transparent {
  border-color: transparent;
}
.border-b-\\[\\#0308C4\\]\\/20 {
  border-bottom-color: rgb(3 8 196 / 0.2);
}
.border-b-primary\\/10 {
  border-bottom-color: rgb(0 60 159 / 0.1);
}
.border-l-\\[\\#F1F1F1\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(241 241 241 / var(--tw-border-opacity));
}
.border-l-primary {
  --tw-border-opacity: 1;
  border-left-color: rgb(0 60 159 / var(--tw-border-opacity));
}
.\\!bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 60 159 / var(--tw-bg-opacity)) !important;
}
.\\!bg-primary\\/10 {
  background-color: rgb(0 60 159 / 0.1) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#0008C3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 8 195 / var(--tw-bg-opacity));
}
.bg-\\[\\#0008C3\\]\\/10 {
  background-color: rgb(0 8 195 / 0.1);
}
.bg-\\[\\#0008C3\\]\\/20 {
  background-color: rgb(0 8 195 / 0.2);
}
.bg-\\[\\#0008C3\\]\\/30 {
  background-color: rgb(0 8 195 / 0.3);
}
.bg-\\[\\#0308C4\\]\\/10 {
  background-color: rgb(3 8 196 / 0.1);
}
.bg-\\[\\#0C6DB1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 109 177 / var(--tw-bg-opacity));
}
.bg-\\[\\#E6E6F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#E6E7F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 231 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#EBF0FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 240 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#EBF0FA\\]\\/\\[0\\.45\\] {
  background-color: rgb(235 240 250 / 0.45);
}
.bg-\\[\\#EDF8F1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 248 241 / var(--tw-bg-opacity));
}
.bg-\\[\\#F7F7FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFECEB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 236 235 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-gray-200\\/50 {
  background-color: rgb(229 231 235 / 0.5);
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 60 159 / var(--tw-bg-opacity));
}
.bg-primary\\/10 {
  background-color: rgb(0 60 159 / 0.1);
}
.bg-primary\\/20 {
  background-color: rgb(0 60 159 / 0.2);
}
.bg-primary\\/30 {
  background-color: rgb(0 60 159 / 0.3);
}
.bg-primary\\/40 {
  background-color: rgb(0 60 159 / 0.4);
}
.bg-primary\\/5 {
  background-color: rgb(0 60 159 / 0.05);
}
.bg-primary\\/50 {
  background-color: rgb(0 60 159 / 0.5);
}
.bg-primary\\/\\[0\\.05\\] {
  background-color: rgb(0 60 159 / 0.05);
}
.bg-primary\\/\\[0\\.06\\] {
  background-color: rgb(0 60 159 / 0.06);
}
.bg-primary\\/\\[0\\.08\\] {
  background-color: rgb(0 60 159 / 0.08);
}
.bg-primary\\/\\[0\\.25\\] {
  background-color: rgb(0 60 159 / 0.25);
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.bg-textPrimary\\/10 {
  background-color: rgb(41 45 50 / 0.1);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#0008C3\\]\\/\\[0\\.49\\] {
  --tw-gradient-from: rgb(0 8 195 / 0.49) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 8 195 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#0008C3\\]\\/40 {
  --tw-gradient-to: rgb(0 8 195 / 0.4) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-contain {
  background-size: contain;
}
.fill-blue-600 {
  fill: #2563eb;
}
.fill-red-200 {
  fill: #fecaca;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[3px\\] {
  padding: 3px;
}
.p-\\[3vw\\] {
  padding: 3vw;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[5vw\\] {
  padding: 5vw;
}
.p-\\[6vw\\] {
  padding: 6vw;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!px-\\[12vw\\] {
  padding-left: 12vw !important;
  padding-right: 12vw !important;
}
.\\!px-\\[2vw\\] {
  padding-left: 2vw !important;
  padding-right: 2vw !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.\\!py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.\\!py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.\\!py-\\[14px\\] {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
.\\!py-\\[18px\\] {
  padding-top: 18px !important;
  padding-bottom: 18px !important;
}
.\\!py-\\[2\\.5vw\\] {
  padding-top: 2.5vw !important;
  padding-bottom: 2.5vw !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[10\\%\\] {
  padding-left: 10%;
  padding-right: 10%;
}
.px-\\[10vw\\] {
  padding-left: 10vw;
  padding-right: 10vw;
}
.px-\\[12vw\\] {
  padding-left: 12vw;
  padding-right: 12vw;
}
.px-\\[15\\%\\] {
  padding-left: 15%;
  padding-right: 15%;
}
.px-\\[17px\\] {
  padding-left: 17px;
  padding-right: 17px;
}
.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[19px\\] {
  padding-left: 19px;
  padding-right: 19px;
}
.px-\\[1vw\\] {
  padding-left: 1vw;
  padding-right: 1vw;
}
.px-\\[25vw\\] {
  padding-left: 25vw;
  padding-right: 25vw;
}
.px-\\[2vw\\] {
  padding-left: 2vw;
  padding-right: 2vw;
}
.px-\\[31px\\] {
  padding-left: 31px;
  padding-right: 31px;
}
.px-\\[34px\\] {
  padding-left: 34px;
  padding-right: 34px;
}
.px-\\[3vw\\] {
  padding-left: 3vw;
  padding-right: 3vw;
}
.px-\\[4vw\\] {
  padding-left: 4vw;
  padding-right: 4vw;
}
.px-\\[53px\\] {
  padding-left: 53px;
  padding-right: 53px;
}
.px-\\[5vw\\] {
  padding-left: 5vw;
  padding-right: 5vw;
}
.px-\\[6vw\\] {
  padding-left: 6vw;
  padding-right: 6vw;
}
.px-\\[7vw\\] {
  padding-left: 7vw;
  padding-right: 7vw;
}
.px-\\[80px\\] {
  padding-left: 80px;
  padding-right: 80px;
}
.px-\\[8vw\\] {
  padding-left: 8vw;
  padding-right: 8vw;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[17px\\] {
  padding-top: 17px;
  padding-bottom: 17px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[20\\%\\] {
  padding-top: 20%;
  padding-bottom: 20%;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-\\[25px\\] {
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[28px\\] {
  padding-top: 28px;
  padding-bottom: 28px;
}
.py-\\[2vh\\] {
  padding-top: 2vh;
  padding-bottom: 2vh;
}
.py-\\[2vw\\] {
  padding-top: 2vw;
  padding-bottom: 2vw;
}
.py-\\[3\\.5vw\\] {
  padding-top: 3.5vw;
  padding-bottom: 3.5vw;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[34px\\] {
  padding-top: 34px;
  padding-bottom: 34px;
}
.py-\\[38px\\] {
  padding-top: 38px;
  padding-bottom: 38px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[4vh\\] {
  padding-top: 4vh;
  padding-bottom: 4vh;
}
.py-\\[50px\\] {
  padding-top: 50px;
  padding-bottom: 50px;
}
.py-\\[5vh\\] {
  padding-top: 5vh;
  padding-bottom: 5vh;
}
.py-\\[60px\\] {
  padding-top: 60px;
  padding-bottom: 60px;
}
.py-\\[6vw\\] {
  padding-top: 6vw;
  padding-bottom: 6vw;
}
.py-\\[9\\%\\] {
  padding-top: 9%;
  padding-bottom: 9%;
}
.\\!pl-10 {
  padding-left: 2.5rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pb-\\[10\\%\\] {
  padding-bottom: 10%;
}
.pb-\\[100px\\] {
  padding-bottom: 100px;
}
.pb-\\[101px\\] {
  padding-bottom: 101px;
}
.pb-\\[10vh\\] {
  padding-bottom: 10vh;
}
.pb-\\[11\\%\\] {
  padding-bottom: 11%;
}
.pb-\\[110px\\] {
  padding-bottom: 110px;
}
.pb-\\[120px\\] {
  padding-bottom: 120px;
}
.pb-\\[15px\\] {
  padding-bottom: 15px;
}
.pb-\\[15vh\\] {
  padding-bottom: 15vh;
}
.pb-\\[2vh\\] {
  padding-bottom: 2vh;
}
.pb-\\[2vw\\] {
  padding-bottom: 2vw;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pb-\\[30vw\\] {
  padding-bottom: 30vw;
}
.pb-\\[34px\\] {
  padding-bottom: 34px;
}
.pb-\\[40vh\\] {
  padding-bottom: 40vh;
}
.pb-\\[5\\%\\] {
  padding-bottom: 5%;
}
.pb-\\[50px\\] {
  padding-bottom: 50px;
}
.pb-\\[51px\\] {
  padding-bottom: 51px;
}
.pb-\\[5vw\\] {
  padding-bottom: 5vw;
}
.pb-\\[6vw\\] {
  padding-bottom: 6vw;
}
.pb-\\[77px\\] {
  padding-bottom: 77px;
}
.pb-\\[80px\\] {
  padding-bottom: 80px;
}
.pb-\\[94px\\] {
  padding-bottom: 94px;
}
.pb-\\[9vw\\] {
  padding-bottom: 9vw;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-\\[10vw\\] {
  padding-left: 10vw;
}
.pr-0 {
  padding-right: 0px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pr-\\[3\\.8\\%\\] {
  padding-right: 3.8%;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pr-\\[6vw\\] {
  padding-right: 6vw;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-\\[0\\.5vw\\] {
  padding-top: 0.5vw;
}
.pt-\\[10vh\\] {
  padding-top: 10vh;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pt-\\[30px\\] {
  padding-top: 30px;
}
.\\!text-left {
  text-align: left !important;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.\\!text-right {
  text-align: right !important;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.font-IranSans {
  font-family: IranSans, cursive;
}
.font-JavanWeb {
  font-family: JavanWeb, cursive;
}
.\\!text-\\[0\\.5vw\\] {
  font-size: 0.5vw !important;
}
.\\!text-\\[0\\.8vw\\] {
  font-size: 0.8vw !important;
}
.\\!text-\\[3vw\\] {
  font-size: 3vw !important;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.1vw\\] {
  font-size: 1.1vw;
}
.text-\\[1\\.2vw\\] {
  font-size: 1.2vw;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[12vw\\] {
  font-size: 12vw;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[1vw\\] {
  font-size: 1vw;
}
.text-\\[2\\.3vw\\] {
  font-size: 2.3vw;
}
.text-\\[2\\.5vw\\] {
  font-size: 2.5vw;
}
.text-\\[2\\.6vw\\] {
  font-size: 2.6vw;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22\\.5px\\] {
  font-size: 22.5px;
}
.text-\\[2vw\\] {
  font-size: 2vw;
}
.text-\\[3\\.2vw\\] {
  font-size: 3.2vw;
}
.text-\\[3\\.5vw\\] {
  font-size: 3.5vw;
}
.text-\\[3\\.7vw\\] {
  font-size: 3.7vw;
}
.text-\\[3\\.8vw\\] {
  font-size: 3.8vw;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[3vw\\] {
  font-size: 3vw;
}
.text-\\[4vw\\] {
  font-size: 4vw;
}
.text-\\[5vw\\] {
  font-size: 5vw;
}
.text-\\[6\\.5vw\\] {
  font-size: 6.5vw;
}
.text-\\[6vw\\] {
  font-size: 6vw;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[550\\] {
  font-weight: 550;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-\\[800\\] {
  font-weight: 800;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.tracking-\\[0\\.02rem\\] {
  letter-spacing: 0.02rem;
}
.tracking-\\[0\\.5vw\\] {
  letter-spacing: 0.5vw;
}
.tracking-\\[0px\\] {
  letter-spacing: 0px;
}
.tracking-\\[11px\\] {
  letter-spacing: 11px;
}
.tracking-\\[7\\.5\\%\\] {
  letter-spacing: 7.5%;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.\\!text-primary {
  --tw-text-opacity: 1 !important;
  color: rgb(0 60 159 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#0008C3\\] {
  --tw-text-opacity: 1;
  color: rgb(0 8 195 / var(--tw-text-opacity));
}
.text-\\[\\#0008C3\\]\\/50 {
  color: rgb(0 8 195 / 0.5);
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#00AE07\\] {
  --tw-text-opacity: 1;
  color: rgb(0 174 7 / var(--tw-text-opacity));
}
.text-\\[\\#1DAE60\\] {
  --tw-text-opacity: 1;
  color: rgb(29 174 96 / var(--tw-text-opacity));
}
.text-\\[\\#292D32\\] {
  --tw-text-opacity: 1;
  color: rgb(41 45 50 / var(--tw-text-opacity));
}
.text-\\[\\#292D32\\]\\/50 {
  color: rgb(41 45 50 / 0.5);
}
.text-\\[\\#454545\\] {
  --tw-text-opacity: 1;
  color: rgb(69 69 69 / var(--tw-text-opacity));
}
.text-\\[\\#54575B\\] {
  --tw-text-opacity: 1;
  color: rgb(84 87 91 / var(--tw-text-opacity));
}
.text-\\[\\#7D8A99\\] {
  --tw-text-opacity: 1;
  color: rgb(125 138 153 / var(--tw-text-opacity));
}
.text-\\[\\#868686\\] {
  --tw-text-opacity: 1;
  color: rgb(134 134 134 / var(--tw-text-opacity));
}
.text-\\[\\#8C8C8C\\] {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity));
}
.text-\\[\\#8E9091\\] {
  --tw-text-opacity: 1;
  color: rgb(142 144 145 / var(--tw-text-opacity));
}
.text-\\[\\#949699\\] {
  --tw-text-opacity: 1;
  color: rgb(148 150 153 / var(--tw-text-opacity));
}
.text-\\[\\#999CE7\\] {
  --tw-text-opacity: 1;
  color: rgb(153 156 231 / var(--tw-text-opacity));
}
.text-\\[\\#DADADA\\] {
  --tw-text-opacity: 1;
  color: rgb(218 218 218 / var(--tw-text-opacity));
}
.text-\\[\\#FF0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-\\[14\\] {
  color: 14;
}
.text-\\[700\\] {
  color: 700;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-black\\/50 {
  color: rgb(0 0 0 / 0.5);
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-700\\/40 {
  color: rgb(55 65 81 / 0.4);
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(0 60 159 / var(--tw-text-opacity));
}
.text-primary\\/20 {
  color: rgb(0 60 159 / 0.2);
}
.text-primary\\/30 {
  color: rgb(0 60 159 / 0.3);
}
.text-primary\\/40 {
  color: rgb(0 60 159 / 0.4);
}
.text-primary\\/50 {
  color: rgb(0 60 159 / 0.5);
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-textPrimary {
  --tw-text-opacity: 1;
  color: rgb(41 45 50 / var(--tw-text-opacity));
}
.text-textPrimary\\/40 {
  color: rgb(41 45 50 / 0.4);
}
.text-textPrimary\\/50 {
  color: rgb(41 45 50 / 0.5);
}
.text-textPrimary\\/60 {
  color: rgb(41 45 50 / 0.6);
}
.text-textPrimary\\/70 {
  color: rgb(41 45 50 / 0.7);
}
.text-textSecondary {
  --tw-text-opacity: 1;
  color: rgb(125 138 153 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur-\\[1\\.1px\\] {
  --tw-blur: blur(1.1px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[15px\\] {
  --tw-blur: blur(15px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[30px\\] {
  --tw-blur: blur(30px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[5px\\] {
  --tw-blur: blur(5px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
      display: none;
    }
/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

/* delete number input arrows */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/* DATE PICKER FONTFAMILY */
.datepicker.default .datepicker-scroll li,
.datepicker.default .datepicker-navbar-btn {
  font-family: "IRANSansWeb" !important;
}

@font-face {
  font-family: IRANSansWeb;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: IRANSansWeb;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: JavanWeb;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}

.javanFont * {
  font-family: "JavanWeb" !important;
}

* {
  font-family: "IRANSansWeb";
  font-weight: 500;
}

input {
  outline: none;
}
/* .diodrumFont {
  font-family: 'Diodrum' !important;
}

.graublauwebFont {
  font-family: 'Graublau' !important;
} */

/* input, textarea {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
} */
.success_animation {
  transition: all 0.7s ease-in-out !important;
}

.global_padding {
  /* px-5 smm2:px-10 md:px-[2%] xl:px-[4%] */
  padding-left: 20px;
  padding-right: 20px;
}
@media screen and (min-width: 550px) {
  .global_padding {
    padding-left: 40px;
    padding-right: 40px;
  }
}
@media screen and (min-width: 768px) {
  .global_padding {
    padding-left: 2%;
    padding-right: 2%;
  }
}
@media screen and (min-width: 1280px) {
  .global_padding {
    padding-left: 4%;
    padding-right: 4%;
  }
}

.element_padding {
  padding-top: 3.6vw;
  padding-bottom: 3.6vw;
  padding-left: 12vw;
  padding-right: 12vw;
}

@media (min-width: 550px) {

  .element_padding {
    padding-top: 2.4vw;
    padding-bottom: 2.4vw;
  }
}

@media (min-width: 768px) {

  .element_padding {
    padding-top: 1.2vw;
    padding-bottom: 1.2vw;
    padding-left: 5vw;
    padding-right: 5vw;
  }
}

@media (min-width: 1280px) {

  .element_padding {
    padding-left: 4vw;
    padding-right: 4vw;
  }
}

@media (min-width: 1400px) {

  .element_padding {
    padding-top: 1vw;
    padding-bottom: 1vw;
  }
}

@media (min-width: 1800px) {

  .element_padding {
    padding-top: 0.8vw;
    padding-bottom: 0.8vw;
    padding-left: 3.6vw;
    padding-right: 3.6vw;
  }
}

/* text-[10px] */
.text-xs {
  font-size: 2.5vw;
}
@media screen and (min-width: 550px) {
  .text-xs {
    font-size: 2.1vw;
  }
}
@media screen and (min-width: 768px) {
  .text-xs {
    font-size: 1vw;
  }
}
@media screen and (min-width: 1180px) {
  .text-xs {
    font-size: 0.9vw;
  }
}
@media screen and (min-width: 1800px) {
  .text-xs {
    font-size: 0.7vw;
  }
}

/* text-[12px] */
.text-sm {
  font-size: 3vw;
}
@media screen and (min-width: 550px) {
  .text-sm {
    font-size: 2.7vw;
  }
}
@media screen and (min-width: 768px) {
  .text-sm {
    font-size: 1.2vw;
  }
}
@media screen and (min-width: 1180px) {
  .text-sm {
    font-size: 1vw;
  }
}
@media screen and (min-width: 1800px) {
  .text-sm {
    font-size: 0.8vw;
  }
}

/* text-[14px] */
.text-md {
  font-size: 3.3vw;
}
@media screen and (min-width: 550px) {
  .text-md {
    font-size: 2.7vw;
  }
}
@media screen and (min-width: 768px) {
  .text-md {
    font-size: 1.5vw;
  }
}
@media screen and (min-width: 1280px) {
  .text-md {
    font-size: 1.1vw;
  }
}
@media screen and (min-width: 1800px) {
  .text-md {
    font-size: 1vw;
  }
}

/* text-[16px] */
.text-lg {
  font-size: 4.2vw;
}
@media screen and (min-width: 550px) {
  .text-lg {
    font-size: 4vw;
  }
}
@media screen and (min-width: 768px) {
  .text-lg {
    font-size: 2vw;
  }
}
@media screen and (min-width: 1280px) {
  .text-lg {
    font-size: 1.7vw;
  }
}
@media screen and (min-width: 1800px) {
  .text-lg {
    font-size: 1.5vw;
  }
}

/* text-[20px] */
.text-xl {
  font-size: 4.5vw;
}
@media screen and (min-width: 550px) {
  .text-xl {
    font-size: 4.2vw;
  }
}
@media screen and (min-width: 768px) {
  .text-xl {
    font-size: 2.2vw;
  }
}
@media screen and (min-width: 1280px) {
  .text-xl {
    font-size: 2vw;
  }
}
@media screen and (min-width: 1800px) {
  .text-xl {
    font-size: 1.7vw;
  }
}

.fix_position {
  position: fixed;
  overflow: hidden;
}

.placeholder\\:\\!text-right::placeholder {
  text-align: right !important;
}

.hover\\:bg-\\[\\#0308C4\\]\\/70:hover {
  background-color: rgb(3 8 196 / 0.7);
}

.hover\\:bg-hover:hover {
  background-color: rgba(0, 8, 195, 0.07);
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(0 60 159 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:border-\\[\\#0308C4\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(3 8 196 / var(--tw-border-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media not all and (min-width: 768px) {

  .max-md\\:hidden {
    display: none;
  }

  .max-md\\:h-\\[105vw\\] {
    height: 105vw;
  }

  .max-md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .max-md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
}

@media (min-width: 350px) {

  .zfold12\\:px-\\[4vw\\] {
    padding-left: 4vw;
    padding-right: 4vw;
  }
}

@media (min-width: 400px) {

  .zfold2\\:gap-x-\\[5vw\\] {
    column-gap: 5vw;
  }
}

@media (min-width: 550px) {

  .smm2\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

@media (min-width: 640px) {

  .sm\\:bottom-\\[30px\\] {
    bottom: 30px;
  }

  .sm\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .sm\\:mt-\\[62px\\] {
    margin-top: 62px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[52px\\] {
    height: 52px;
  }

  .sm\\:h-\\[6rem\\] {
    height: 6rem;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:max-w-\\[700px\\] {
    max-width: 700px;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:px-\\[41px\\] {
    padding-left: 41px;
    padding-right: 41px;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[19px\\] {
    font-size: 19px;
  }

  .sm\\:text-\\[21px\\] {
    font-size: 21px;
  }

  .sm\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-\\[3vw\\] {
    font-size: 3vw;
  }

  .sm\\:text-\\[4vw\\] {
    font-size: 4vw;
  }

  .sm\\:font-\\[500\\] {
    font-weight: 500;
  }

  .sm\\:font-\\[700\\] {
    font-weight: 700;
  }

  .sm\\:font-extrabold {
    font-weight: 800;
  }
}

@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:relative {
    position: relative;
  }

  .md\\:-bottom-\\[120px\\] {
    bottom: -120px;
  }

  .md\\:-left-0 {
    left: -0px;
  }

  .md\\:-top-\\[94px\\] {
    top: -94px;
  }

  .md\\:bottom-0 {
    bottom: 0px;
  }

  .md\\:bottom-\\[0vw\\] {
    bottom: 0vw;
  }

  .md\\:left-\\[3vw\\] {
    left: 3vw;
  }

  .md\\:right-auto {
    right: auto;
  }

  .md\\:order-first {
    order: -9999;
  }

  .md\\:mx-\\[2vw\\] {
    margin-left: 2vw;
    margin-right: 2vw;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-20 {
    margin-bottom: 5rem;
  }

  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .md\\:mb-\\[0px\\] {
    margin-bottom: 0px;
  }

  .md\\:mb-\\[10px\\] {
    margin-bottom: 10px;
  }

  .md\\:mb-\\[10vh\\] {
    margin-bottom: 10vh;
  }

  .md\\:mb-\\[14px\\] {
    margin-bottom: 14px;
  }

  .md\\:mb-\\[5vh\\] {
    margin-bottom: 5vh;
  }

  .md\\:mb-\\[8px\\] {
    margin-bottom: 8px;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mt-\\[10vh\\] {
    margin-top: 10vh;
  }

  .md\\:mt-\\[20px\\] {
    margin-top: 20px;
  }

  .md\\:mt-\\[5vh\\] {
    margin-top: 5vh;
  }

  .md\\:mt-\\[75px\\] {
    margin-top: 75px;
  }

  .md\\:mt-\\[7vh\\] {
    margin-top: 7vh;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:\\!h-full {
    height: 100% !important;
  }

  .md\\:h-\\[1\\.5vw\\] {
    height: 1.5vw;
  }

  .md\\:h-\\[107px\\] {
    height: 107px;
  }

  .md\\:h-\\[10vh\\] {
    height: 10vh;
  }

  .md\\:h-\\[12vw\\] {
    height: 12vw;
  }

  .md\\:h-\\[20px\\] {
    height: 20px;
  }

  .md\\:h-\\[280px\\] {
    height: 280px;
  }

  .md\\:h-\\[3\\.7vw\\] {
    height: 3.7vw;
  }

  .md\\:h-\\[300px\\] {
    height: 300px;
  }

  .md\\:h-\\[45vh\\] {
    height: 45vh;
  }

  .md\\:h-\\[460px\\] {
    height: 460px;
  }

  .md\\:h-\\[47px\\] {
    height: 47px;
  }

  .md\\:h-\\[4vw\\] {
    height: 4vw;
  }

  .md\\:h-\\[5\\.8vw\\] {
    height: 5.8vw;
  }

  .md\\:h-\\[50\\%\\] {
    height: 50%;
  }

  .md\\:h-\\[50vh\\] {
    height: 50vh;
  }

  .md\\:h-\\[55px\\] {
    height: 55px;
  }

  .md\\:h-\\[60vh\\] {
    height: 60vh;
  }

  .md\\:h-\\[65\\%\\] {
    height: 65%;
  }

  .md\\:h-\\[65vh\\] {
    height: 65vh;
  }

  .md\\:h-\\[66px\\] {
    height: 66px;
  }

  .md\\:h-\\[7vw\\] {
    height: 7vw;
  }

  .md\\:h-\\[8vw\\] {
    height: 8vw;
  }

  .md\\:h-\\[90\\%\\] {
    height: 90%;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:max-h-\\[20vw\\] {
    max-height: 20vw;
  }

  .md\\:w-\\[1\\.5vw\\] {
    width: 1.5vw;
  }

  .md\\:w-\\[10vw\\] {
    width: 10vw;
  }

  .md\\:w-\\[12vw\\] {
    width: 12vw;
  }

  .md\\:w-\\[13vw\\] {
    width: 13vw;
  }

  .md\\:w-\\[14vw\\] {
    width: 14vw;
  }

  .md\\:w-\\[16\\%\\] {
    width: 16%;
  }

  .md\\:w-\\[16px\\] {
    width: 16px;
  }

  .md\\:w-\\[17px\\] {
    width: 17px;
  }

  .md\\:w-\\[18\\%\\] {
    width: 18%;
  }

  .md\\:w-\\[22vw\\] {
    width: 22vw;
  }

  .md\\:w-\\[266px\\] {
    width: 266px;
  }

  .md\\:w-\\[2vw\\] {
    width: 2vw;
  }

  .md\\:w-\\[30vw\\] {
    width: 30vw;
  }

  .md\\:w-\\[3vw\\] {
    width: 3vw;
  }

  .md\\:w-\\[40vw\\] {
    width: 40vw;
  }

  .md\\:w-\\[42vw\\] {
    width: 42vw;
  }

  .md\\:w-\\[45vw\\] {
    width: 45vw;
  }

  .md\\:w-\\[500px\\] {
    width: 500px;
  }

  .md\\:w-\\[50vw\\] {
    width: 50vw;
  }

  .md\\:w-\\[6vw\\] {
    width: 6vw;
  }

  .md\\:w-\\[7vw\\] {
    width: 7vw;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-\\[8vw\\] {
    width: 8vw;
  }

  .md\\:w-\\[94px\\] {
    width: 94px;
  }

  .md\\:w-\\[9px\\] {
    width: 9px;
  }

  .md\\:w-\\[9vw\\] {
    width: 9vw;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-\\[50vw\\] {
    max-width: 50vw;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:\\!flex-col {
    flex-direction: column !important;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-\\[7vw\\] {
    gap: 7vw;
  }

  .md\\:gap-x-2 {
    column-gap: 0.5rem;
  }

  .md\\:gap-x-3 {
    column-gap: 0.75rem;
  }

  .md\\:gap-x-5 {
    column-gap: 1.25rem;
  }

  .md\\:gap-x-\\[10\\%\\] {
    column-gap: 10%;
  }

  .md\\:gap-x-\\[12vw\\] {
    column-gap: 12vw;
  }

  .md\\:gap-x-\\[14px\\] {
    column-gap: 14px;
  }

  .md\\:gap-x-\\[1vw\\] {
    column-gap: 1vw;
  }

  .md\\:gap-x-\\[2\\.5vw\\] {
    column-gap: 2.5vw;
  }

  .md\\:gap-x-\\[25px\\] {
    column-gap: 25px;
  }

  .md\\:gap-x-\\[2vw\\] {
    column-gap: 2vw;
  }

  .md\\:gap-x-\\[33px\\] {
    column-gap: 33px;
  }

  .md\\:gap-x-\\[4\\%\\] {
    column-gap: 4%;
  }

  .md\\:gap-x-\\[50px\\] {
    column-gap: 50px;
  }

  .md\\:gap-x-\\[6vw\\] {
    column-gap: 6vw;
  }

  .md\\:gap-x-\\[7vw\\] {
    column-gap: 7vw;
  }

  .md\\:gap-x-\\[8\\%\\] {
    column-gap: 8%;
  }

  .md\\:gap-y-1 {
    row-gap: 0.25rem;
  }

  .md\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .md\\:gap-y-\\[0\\] {
    row-gap: 0;
  }

  .md\\:gap-y-\\[10vh\\] {
    row-gap: 10vh;
  }

  .md\\:gap-y-\\[12px\\] {
    row-gap: 12px;
  }

  .md\\:gap-y-\\[1vw\\] {
    row-gap: 1vw;
  }

  .md\\:gap-y-\\[2vw\\] {
    row-gap: 2vw;
  }

  .md\\:gap-y-\\[31px\\] {
    row-gap: 31px;
  }

  .md\\:gap-y-\\[33px\\] {
    row-gap: 33px;
  }

  .md\\:gap-y-\\[50px\\] {
    row-gap: 50px;
  }

  .md\\:gap-y-\\[5vh\\] {
    row-gap: 5vh;
  }

  .md\\:gap-y-\\[6vh\\] {
    row-gap: 6vh;
  }

  .md\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .md\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }

  .md\\:rounded-\\[24px\\] {
    border-radius: 24px;
  }

  .md\\:rounded-\\[34px\\] {
    border-radius: 34px;
  }

  .md\\:rounded-b-\\[24px\\] {
    border-bottom-right-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .md\\:border-\\[1px\\] {
    border-width: 1px;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .md\\:border-b-\\[0px\\] {
    border-bottom-width: 0px;
  }

  .md\\:border-b-\\[1px\\] {
    border-bottom-width: 1px;
  }

  .md\\:border-none {
    border-style: none;
  }

  .md\\:border-\\[\\#0008C3\\]\\/50 {
    border-color: rgb(0 8 195 / 0.5);
  }

  .md\\:border-transparent {
    border-color: transparent;
  }

  .md\\:bg-primary\\/10 {
    background-color: rgb(0 60 159 / 0.1);
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-7 {
    padding: 1.75rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:p-\\[30px\\] {
    padding: 30px;
  }

  .md\\:\\!px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .md\\:\\!px-\\[3vw\\] {
    padding-left: 3vw !important;
    padding-right: 3vw !important;
  }

  .md\\:\\!px-\\[40px\\] {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }

  .md\\:\\!py-\\[0\\.9vw\\] {
    padding-top: 0.9vw !important;
    padding-bottom: 0.9vw !important;
  }

  .md\\:\\!py-\\[18px\\] {
    padding-top: 18px !important;
    padding-bottom: 18px !important;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-\\[10\\%\\] {
    padding-left: 10%;
    padding-right: 10%;
  }

  .md\\:px-\\[10vw\\] {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  .md\\:px-\\[12vw\\] {
    padding-left: 12vw;
    padding-right: 12vw;
  }

  .md\\:px-\\[1vw\\] {
    padding-left: 1vw;
    padding-right: 1vw;
  }

  .md\\:px-\\[2\\%\\] {
    padding-left: 2%;
    padding-right: 2%;
  }

  .md\\:px-\\[2\\.2vw\\] {
    padding-left: 2.2vw;
    padding-right: 2.2vw;
  }

  .md\\:px-\\[2vw\\] {
    padding-left: 2vw;
    padding-right: 2vw;
  }

  .md\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .md\\:px-\\[32px\\] {
    padding-left: 32px;
    padding-right: 32px;
  }

  .md\\:px-\\[3vw\\] {
    padding-left: 3vw;
    padding-right: 3vw;
  }

  .md\\:px-\\[42px\\] {
    padding-left: 42px;
    padding-right: 42px;
  }

  .md\\:px-\\[52px\\] {
    padding-left: 52px;
    padding-right: 52px;
  }

  .md\\:px-\\[57px\\] {
    padding-left: 57px;
    padding-right: 57px;
  }

  .md\\:px-\\[5vw\\] {
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .md\\:px-\\[60px\\] {
    padding-left: 60px;
    padding-right: 60px;
  }

  .md\\:px-\\[7vw\\] {
    padding-left: 7vw;
    padding-right: 7vw;
  }

  .md\\:px-\\[80px\\] {
    padding-left: 80px;
    padding-right: 80px;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-\\[0\\.9vw\\] {
    padding-top: 0.9vw;
    padding-bottom: 0.9vw;
  }

  .md\\:py-\\[0\\] {
    padding-top: 0;
    padding-bottom: 0;
  }

  .md\\:py-\\[1\\.2vw\\] {
    padding-top: 1.2vw;
    padding-bottom: 1.2vw;
  }

  .md\\:py-\\[10vh\\] {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

  .md\\:py-\\[14px\\] {
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .md\\:py-\\[15\\%\\] {
    padding-top: 15%;
    padding-bottom: 15%;
  }

  .md\\:py-\\[17vh\\] {
    padding-top: 17vh;
    padding-bottom: 17vh;
  }

  .md\\:py-\\[1vw\\] {
    padding-top: 1vw;
    padding-bottom: 1vw;
  }

  .md\\:py-\\[50px\\] {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .md\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .md\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pb-\\[10vh\\] {
    padding-bottom: 10vh;
  }

  .md\\:pb-\\[15\\%\\] {
    padding-bottom: 15%;
  }

  .md\\:pb-\\[17vh\\] {
    padding-bottom: 17vh;
  }

  .md\\:pb-\\[18px\\] {
    padding-bottom: 18px;
  }

  .md\\:pb-\\[20\\%\\] {
    padding-bottom: 20%;
  }

  .md\\:pb-\\[50px\\] {
    padding-bottom: 50px;
  }

  .md\\:pb-\\[80px\\] {
    padding-bottom: 80px;
  }

  .md\\:pl-\\[4vw\\] {
    padding-left: 4vw;
  }

  .md\\:pr-\\[10vw\\] {
    padding-right: 10vw;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:pt-\\[15\\%\\] {
    padding-top: 15%;
  }

  .md\\:pt-\\[5vh\\] {
    padding-top: 5vh;
  }

  .md\\:pt-\\[8\\%\\] {
    padding-top: 8%;
  }

  .md\\:pt-\\[90px\\] {
    padding-top: 90px;
  }

  .md\\:pt-\\[9vh\\] {
    padding-top: 9vh;
  }

  .md\\:pt-\\[\\] {
    padding-top: ;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:\\!text-\\[0\\.9vw\\] {
    font-size: 0.9vw !important;
  }

  .md\\:\\!text-\\[1\\.2vw\\] {
    font-size: 1.2vw !important;
  }

  .md\\:\\!text-\\[1\\.5vw\\] {
    font-size: 1.5vw !important;
  }

  .md\\:\\!text-\\[1vw\\] {
    font-size: 1vw !important;
  }

  .md\\:\\!text-\\[2vw\\] {
    font-size: 2vw !important;
  }

  .md\\:text-\\[0\\.7vw\\] {
    font-size: 0.7vw;
  }

  .md\\:text-\\[0\\.8vw\\] {
    font-size: 0.8vw;
  }

  .md\\:text-\\[0\\.9vw\\] {
    font-size: 0.9vw;
  }

  .md\\:text-\\[1\\.1vw\\] {
    font-size: 1.1vw;
  }

  .md\\:text-\\[1\\.2vw\\] {
    font-size: 1.2vw;
  }

  .md\\:text-\\[1\\.3vw\\] {
    font-size: 1.3vw;
  }

  .md\\:text-\\[1\\.4vw\\] {
    font-size: 1.4vw;
  }

  .md\\:text-\\[1\\.6vw\\] {
    font-size: 1.6vw;
  }

  .md\\:text-\\[1\\.7vw\\] {
    font-size: 1.7vw;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .md\\:text-\\[1vw\\] {
    font-size: 1vw;
  }

  .md\\:text-\\[2\\.4vw\\] {
    font-size: 2.4vw;
  }

  .md\\:text-\\[2\\.5vw\\] {
    font-size: 2.5vw;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .md\\:text-\\[2vw\\] {
    font-size: 2vw;
  }

  .md\\:text-\\[30\\.5px\\] {
    font-size: 30.5px;
  }

  .md\\:text-\\[33px\\] {
    font-size: 33px;
  }

  .md\\:text-\\[3vw\\] {
    font-size: 3vw;
  }

  .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .md\\:text-\\[64px\\] {
    font-size: 64px;
  }

  .md\\:text-\\[6vw\\] {
    font-size: 6vw;
  }

  .md\\:text-primary {
    --tw-text-opacity: 1;
    color: rgb(0 60 159 / var(--tw-text-opacity));
  }
}

@media (min-width: 1000px) {

  .md2\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md2\\:gap-x-\\[20px\\] {
    column-gap: 20px;
  }

  .md2\\:gap-x-\\[50px\\] {
    column-gap: 50px;
  }

  .md2\\:gap-x-\\[60px\\] {
    column-gap: 60px;
  }

  .md2\\:px-\\[50px\\] {
    padding-left: 50px;
    padding-right: 50px;
  }

  .md2\\:px-\\[80px\\] {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media (min-width: 1024px) {

  .lg\\:block {
    display: block;
  }

  .lg\\:h-\\[3\\.6vw\\] {
    height: 3.6vw;
  }

  .lg\\:h-\\[62px\\] {
    height: 62px;
  }

  .lg\\:w-\\[23vw\\] {
    width: 23vw;
  }

  .lg\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .lg\\:w-\\[4vw\\] {
    width: 4vw;
  }

  .lg\\:gap-x-\\[3vw\\] {
    column-gap: 3vw;
  }

  .lg\\:p-\\[6\\%\\] {
    padding: 6%;
  }

  .lg\\:px-\\[4\\%\\] {
    padding-left: 4%;
    padding-right: 4%;
  }

  .lg\\:px-\\[5vw\\] {
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .lg\\:\\!text-\\[1\\.8vw\\] {
    font-size: 1.8vw !important;
  }

  .lg\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lg\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .lg\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .lg\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .lg\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .lg\\:text-\\[38px\\] {
    font-size: 38px;
  }
}

@media (min-width: 1180px) {

  .lg2\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg2\\:mt-\\[105px\\] {
    margin-top: 105px;
  }

  .lg2\\:mt-\\[45px\\] {
    margin-top: 45px;
  }

  .lg2\\:h-\\[220px\\] {
    height: 220px;
  }

  .lg2\\:h-\\[69px\\] {
    height: 69px;
  }

  .lg2\\:w-\\[40vw\\] {
    width: 40vw;
  }

  .lg2\\:gap-x-\\[11vw\\] {
    column-gap: 11vw;
  }

  .lg2\\:gap-x-\\[120px\\] {
    column-gap: 120px;
  }

  .lg2\\:gap-x-\\[15vw\\] {
    column-gap: 15vw;
  }

  .lg2\\:gap-x-\\[16vw\\] {
    column-gap: 16vw;
  }

  .lg2\\:gap-x-\\[70px\\] {
    column-gap: 70px;
  }

  .lg2\\:gap-x-\\[94px\\] {
    column-gap: 94px;
  }

  .lg2\\:gap-y-\\[70px\\] {
    row-gap: 70px;
  }

  .lg2\\:px-\\[100px\\] {
    padding-left: 100px;
    padding-right: 100px;
  }

  .lg2\\:px-\\[10vw\\] {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  .lg2\\:px-\\[12vw\\] {
    padding-left: 12vw;
    padding-right: 12vw;
  }

  .lg2\\:px-\\[15vw\\] {
    padding-left: 15vw;
    padding-right: 15vw;
  }

  .lg2\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .lg2\\:px-\\[4\\%\\] {
    padding-left: 4%;
    padding-right: 4%;
  }

  .lg2\\:px-\\[90px\\] {
    padding-left: 90px;
    padding-right: 90px;
  }

  .lg2\\:pt-4 {
    padding-top: 1rem;
  }

  .lg2\\:text-\\[0\\.7vw\\] {
    font-size: 0.7vw;
  }

  .lg2\\:text-\\[0\\.8vw\\] {
    font-size: 0.8vw;
  }

  .lg2\\:text-\\[0\\.9vw\\] {
    font-size: 0.9vw;
  }

  .lg2\\:text-\\[14px\\] {
    font-size: 14px;
  }
}

@media (min-width: 1280px) {

  .xl\\:h-\\[1\\.5vw\\] {
    height: 1.5vw;
  }

  .xl\\:h-\\[4vw\\] {
    height: 4vw;
  }

  .xl\\:h-\\[74px\\] {
    height: 74px;
  }

  .xl\\:h-\\[9vw\\] {
    height: 9vw;
  }

  .xl\\:w-\\[1\\.5vw\\] {
    width: 1.5vw;
  }

  .xl\\:w-\\[20\\%\\] {
    width: 20%;
  }

  .xl\\:w-\\[20vw\\] {
    width: 20vw;
  }

  .xl\\:w-\\[25vw\\] {
    width: 25vw;
  }

  .xl\\:w-\\[35vw\\] {
    width: 35vw;
  }

  .xl\\:w-\\[40vw\\] {
    width: 40vw;
  }

  .xl\\:w-\\[47\\%\\] {
    width: 47%;
  }

  .xl\\:gap-x-\\[10vw\\] {
    column-gap: 10vw;
  }

  .xl\\:gap-x-\\[140px\\] {
    column-gap: 140px;
  }

  .xl\\:px-\\[100px\\] {
    padding-left: 100px;
    padding-right: 100px;
  }

  .xl\\:px-\\[20vw\\] {
    padding-left: 20vw;
    padding-right: 20vw;
  }

  .xl\\:px-\\[4\\%\\] {
    padding-left: 4%;
    padding-right: 4%;
  }

  .xl\\:pl-\\[2\\.2vw\\] {
    padding-left: 2.2vw;
  }

  .xl\\:\\!text-\\[0\\.8vw\\] {
    font-size: 0.8vw !important;
  }

  .xl\\:text-\\[0\\.8vw\\] {
    font-size: 0.8vw;
  }

  .xl\\:text-\\[0\\.9vw\\] {
    font-size: 0.9vw;
  }

  .xl\\:text-\\[1\\.1vw\\] {
    font-size: 1.1vw;
  }

  .xl\\:text-\\[1\\.2vw\\] {
    font-size: 1.2vw;
  }

  .xl\\:text-\\[1\\.4vw\\] {
    font-size: 1.4vw;
  }

  .xl\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .xl\\:text-\\[1vw\\] {
    font-size: 1vw;
  }

  .xl\\:text-\\[2\\.1vw\\] {
    font-size: 2.1vw;
  }

  .xl\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .xl\\:text-\\[27\\.5px\\] {
    font-size: 27.5px;
  }

  .xl\\:text-\\[27px\\] {
    font-size: 27px;
  }

  .xl\\:text-\\[2vw\\] {
    font-size: 2vw;
  }

  .xl\\:text-\\[38px\\] {
    font-size: 38px;
  }
}

@media (min-width: 1360px) {

  .xl2\\:gap-x-\\[5vw\\] {
    column-gap: 5vw;
  }

  .xl2\\:px-\\[12vw\\] {
    padding-left: 12vw;
    padding-right: 12vw;
  }

  .xl2\\:px-\\[190px\\] {
    padding-left: 190px;
    padding-right: 190px;
  }
}

@media (min-width: 1400px) {

  .xl3\\:pt-\\[6\\%\\] {
    padding-top: 6%;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:w-\\[15\\%\\] {
    width: 15%;
  }

  .\\32xl\\:w-\\[3vw\\] {
    width: 3vw;
  }

  .\\32xl\\:max-w-\\[80vw\\] {
    max-width: 80vw;
  }

  .\\32xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .\\32xl\\:gap-x-\\[170px\\] {
    column-gap: 170px;
  }

  .\\32xl\\:px-\\[107px\\] {
    padding-left: 107px;
    padding-right: 107px;
  }

  .\\32xl\\:px-\\[120px\\] {
    padding-left: 120px;
    padding-right: 120px;
  }

  .\\32xl\\:px-\\[2vw\\] {
    padding-left: 2vw;
    padding-right: 2vw;
  }
}

@media (min-width: 1650px) {

  .\\33xl\\:w-\\[10\\%\\] {
    width: 10%;
  }

  .\\33xl\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .\\33xl\\:gap-x-\\[15\\%\\] {
    column-gap: 15%;
  }

  .\\33xl\\:px-\\[10\\%\\] {
    padding-left: 10%;
    padding-right: 10%;
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:text-gray-300 {
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAmEf,gDAAgD;AAChD;MACE,aAAa;IACf;AAEA,4CAA4C;AAC5C;MACE,wBAAwB,EAAE,gBAAgB;MAC1C,qBAAqB,EAAE,YAAY;IACrC;;AA1EJ,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;;EAEE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,4CAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,4CAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4CAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB;2DACsD;AACxD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;;;;;;GAMG;;AAiBH;;;;;;GAMG;AACH;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IAOE,kBAAkB;IAClB,mBAAmB;EALrB;AACF;AAOA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAGE;EAAA,kBACgD;EADhD,qBACgD;EADhD,kBACgD;EADhD;AACgD;;AADhD;;EAAA;IAAA,kBACgD;IADhD;EACgD;AAAA;;AADhD;;EAAA;IAAA,kBACgD;IADhD,qBACgD;IADhD,iBACgD;IADhD;EACgD;AAAA;;AADhD;;EAAA;IAAA,iBACgD;IADhD;EACgD;AAAA;;AADhD;;EAAA;IAAA,gBACgD;IADhD;EACgD;AAAA;;AADhD;;EAAA;IAAA,kBACgD;IADhD,qBACgD;IADhD,mBACgD;IADhD;EACgD;AAAA;;AAGlD,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAhQA;EAAA;AAiQA;;AAjQA;EAAA;AAiQA;;AAjQA;EAAA;AAiQA;;AAjQA;EAAA,oBAiQA;EAjQA;AAiQA;;AAjQA;EAAA,oBAiQA;EAjQA;AAiQA;;AAjQA;EAAA,sBAiQA;EAjQA;AAiQA;;AAjQA;EAAA,8BAiQA;EAjQA;AAiQA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA,iBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA,oBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,gCAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,4BAiQA;IAjQA;EAiQA;;EAjQA;IAAA,4BAiQA;IAjQA;EAiQA;;EAjQA;IAAA,6BAiQA;IAjQA;EAiQA;;EAjQA;IAAA,6BAiQA;IAjQA;EAiQA;;EAjQA;IAAA,4BAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,oBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,oBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,cAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,oBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,gBAiQA;IAjQA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA,kBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,mBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA;EAiQA;;EAjQA;IAAA,iBAiQA;IAjQA;EAiQA;AAAA;;AAjQA;;EAAA;IAAA,oBAiQA;IAjQA;EAiQA;;EAjQA;IAAA,oBAiQA;IAjQA;EAiQA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* delete number input arrows */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* DATE PICKER FONTFAMILY */\n.datepicker.default .datepicker-scroll li,\n.datepicker.default .datepicker-navbar-btn {\n  font-family: \"IRANSansWeb\" !important;\n}\n\n@font-face {\n  font-family: IRANSansWeb;\n  src: url(\"./assets/fonts/IRANSansMobile\\(FaNum\\)-Medium.ttf\");\n}\n\n@font-face {\n  font-family: IRANSansWeb;\n  src: url(\"./assets/fonts/IRANSansMobile\\(FaNum\\)-Bold.ttf\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: IRANSansWeb;\n  src: url(\"./assets/fonts/IRANSansMobile\\(FaNum\\)-Medium.ttf\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: JavanWeb;\n  src: url(\"./assets/fonts/Javanweb.woff\") format(\"woff\"),\n    url(\"./assets/fonts/Javanweb.woff2\") format(\"woff2\");\n}\n\n.javanFont * {\n  font-family: \"JavanWeb\" !important;\n}\n\n* {\n  font-family: \"IRANSansWeb\";\n  font-weight: 500;\n}\n\ninput {\n  outline: none;\n}\n/* .diodrumFont {\n  font-family: 'Diodrum' !important;\n}\n\n.graublauwebFont {\n  font-family: 'Graublau' !important;\n} */\n\n@layer utilities {\n  @variants responsive {\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    .no-scrollbar::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    .no-scrollbar {\n      -ms-overflow-style: none; /* IE and Edge */\n      scrollbar-width: none; /* Firefox */\n    }\n  }\n}\n\n/* input, textarea {\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n} */\n.success_animation {\n  transition: all 0.7s ease-in-out !important;\n}\n\n.global_padding {\n  /* px-5 smm2:px-10 md:px-[2%] xl:px-[4%] */\n  padding-left: 20px;\n  padding-right: 20px;\n}\n@media screen and (min-width: 550px) {\n  .global_padding {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n@media screen and (min-width: 550px) {\n  .global_padding {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .global_padding {\n    padding-left: 2%;\n    padding-right: 2%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .global_padding {\n    padding-left: 4%;\n    padding-right: 4%;\n  }\n}\n\n.element_padding {\n  @apply py-[3.6vw] smm2:py-[2.4vw] md:py-[1.2vw] xl3:py-[1vw] 4xl:py-[0.8vw]\n  px-[12vw] md:px-[5vw] xl:px-[4vw] 4xl:px-[3.6vw];\n}\n\n/* text-[10px] */\n.text-xs {\n  font-size: 2.5vw;\n}\n@media screen and (min-width: 550px) {\n  .text-xs {\n    font-size: 2.1vw;\n  }\n}\n@media screen and (min-width: 768px) {\n  .text-xs {\n    font-size: 1vw;\n  }\n}\n@media screen and (min-width: 1180px) {\n  .text-xs {\n    font-size: 0.9vw;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .text-xs {\n    font-size: 0.7vw;\n  }\n}\n\n/* text-[12px] */\n.text-sm {\n  font-size: 3vw;\n}\n@media screen and (min-width: 550px) {\n  .text-sm {\n    font-size: 2.7vw;\n  }\n}\n@media screen and (min-width: 768px) {\n  .text-sm {\n    font-size: 1.2vw;\n  }\n}\n@media screen and (min-width: 1180px) {\n  .text-sm {\n    font-size: 1vw;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .text-sm {\n    font-size: 0.8vw;\n  }\n}\n\n/* text-[14px] */\n.text-md {\n  font-size: 3.3vw;\n}\n@media screen and (min-width: 550px) {\n  .text-md {\n    font-size: 2.7vw;\n  }\n}\n@media screen and (min-width: 768px) {\n  .text-md {\n    font-size: 1.5vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .text-md {\n    font-size: 1.1vw;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .text-md {\n    font-size: 1vw;\n  }\n}\n\n/* text-[16px] */\n.text-lg {\n  font-size: 4.2vw;\n}\n@media screen and (min-width: 550px) {\n  .text-lg {\n    font-size: 4vw;\n  }\n}\n@media screen and (min-width: 768px) {\n  .text-lg {\n    font-size: 2vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .text-lg {\n    font-size: 1.7vw;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .text-lg {\n    font-size: 1.5vw;\n  }\n}\n\n/* text-[20px] */\n.text-xl {\n  font-size: 4.5vw;\n}\n@media screen and (min-width: 550px) {\n  .text-xl {\n    font-size: 4.2vw;\n  }\n}\n@media screen and (min-width: 768px) {\n  .text-xl {\n    font-size: 2.2vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .text-xl {\n    font-size: 2vw;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .text-xl {\n    font-size: 1.7vw;\n  }\n}\n\n.fix_position {\n  position: fixed;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
